//switching language
export const CHANGE_LANG = "ChangeLang";
//switching between theme
export const THEME_SELECTION = "ThemeSelection";
